import { useRouter } from '@tanstack/react-router'

// Back action for detail screens: pop the entry the user came from so forward
// and back stay in sync. Pushing the list route instead would leave the detail
// sitting behind it, and the next back would jump forward into the detail again.
// When there is no earlier entry (deep link, push notification, fresh tab) fall
// back to the list route — with `replace`, so the fallback doesn't recreate that
// same ping-pong.
export function useBackTo(fallback: string) {
  const router = useRouter()
  return () => {
    if (router.history.canGoBack()) {
      router.history.back()
    } else {
      void router.navigate({ to: fallback as never, replace: true })
    }
  }
}
